<div class="loader-container">
    <img src="../../../assets/images/loading.gif" alt="">
</div>